<glxy-form-field [required]="required()">
  @if (label()) {
    <glxy-label>
      {{ label() }}
      @if (tooltip()) {
        <mat-icon [glxyTooltip]="tooltip() ?? ''" [highContrast]="false" class="info-icon"> info_outline </mat-icon>
      }
    </glxy-label>
  }

  <form [formGroup]="formGroup()" class="phone-number-form">
    <!-- Country Selection -->
    <glxy-form-field class="phone-input-country" [bottomSpacing]="'none'">
      <mat-select formControlName="country" [panelWidth]="''" (blur)="onBlur()">
        <mat-select-trigger>
          @if (selectedCountry(); as selectedCountry) {
            <p [attr.aria-label]="selectedCountry.countryName">
              {{ selectedCountry.flag }}
            </p>
          } @else {
            <p>{{ 'INBOX.SETTINGS.PHONE_NUMBER_SETTINGS.PHONE_INPUT.INVALID_COUNTRY_CODE' | translate }}</p>
          }
        </mat-select-trigger>
        <mat-option>
          <ngx-mat-select-search
            placeholderLabel="{{ 'INBOX.SETTINGS.PHONE_NUMBER_SETTINGS.PHONE_INPUT.SEARCH_COUNTRY' | translate }}"
            noEntriesFoundLabel="{{
              'INBOX.SETTINGS.PHONE_NUMBER_SETTINGS.PHONE_INPUT.NO_COUNTRIES_FOUND' | translate
            }}"
            [formControl]="searchCountryControl"
          ></ngx-mat-select-search>
        </mat-option>
        @for (option of filteredCountryOptions$ | async; track option.countryCode) {
          <mat-option class="phone-input-country-option" [value]="option.countryCode">
            <span class="phone-input-country-option-calling-code">{{ option.callingCode }}</span>
            <span class="phone-input-country-option-display">({{ option.flag }} {{ option.countryName }})</span>
          </mat-option>
        }
      </mat-select>
    </glxy-form-field>

    <!-- Phone Number -->
    <glxy-form-field class="phone-input-number" [bottomSpacing]="'none'">
      <span class="phone-input-code-prefix" matPrefix>{{ selectedCountryCallingCode() }}</span>
      <input
        matInput
        formControlName="phoneNumber"
        [attr.autocomplete]="disableAutoComplete"
        digitOnly
        type="tel"
        (blur)="onBlur()"
        (keydown.enter)="$event.preventDefault()"
      />

      @if (
        formGroup().hasError('invalidPhoneNumber') &&
        (formGroup().touched || formGroup().dirty || formGroup().value.phoneNumber)
      ) {
        <glxy-error>{{ 'INBOX.SETTINGS.PHONE_NUMBER_SETTINGS.PHONE_INPUT.VALIDATION_ERROR' | translate }}</glxy-error>
      }
    </glxy-form-field>

    @if (formGroup().controls.extension) {
      <!-- Extension -->
      <glxy-form-field class="phone-input-extension" [bottomSpacing]="'none'">
        <input
          matInput
          formControlName="extension"
          placeholder="Ext"
          [attr.autocomplete]="disableAutoComplete"
          digitOnly
          type="tel"
          (blur)="onBlur()"
          (keydown.enter)="$event.preventDefault()"
        />
      </glxy-form-field>
    }
  </form>

  @if (hint()) {
    <glxy-hint>{{ hint() }}</glxy-hint>
  }
</glxy-form-field>
